// NotAuthorized.js
import React from 'react';
import { Typography, Box } from '@mui/joy';
import  imgEbn  from '../Images/LogoEBNLogin.png';
const NotAuthorized = () => {
    return (
        <Box sx={{ height: '90vh', textAlign: 'center', mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Box
              component={"img"}
              src={imgEbn}
              sx={{  height: '30%', borderRadius: '8px',}}
            />

            
            <Typography level="h1" sx={{  mb: 2 ,color: '#757575' }}>
             Non autorisé
            </Typography>
            <Typography level="h4" sx={{ color: '#757575'}} >
            Vous n'avez pas la permission d'accéder à cette page.
            </Typography>
        </Box>
    );
};

export default NotAuthorized;
